<template>
    <div class="bcw bcw__feed">
        <header>
            <p class="title">{{ trans('dashboard.feed.title1') }} <span>{{ trans('dashboard.feed.title2') }}</span></p>
            <p class="subtitle">{{ trans('dashboard.feed.sub') }}</p>
        </header>
        <main>
            <tabs :tabs="myTabs" @switchTabControl="switchActiveTab"></tabs>
            <div class="feed__content scrollbar--vertical">

                <div v-if="loading" class="feed__load">
                    <loader :dim="64"></loader>
                    <p>{{ trans('dashboard.general.retrieving') }}</p>
                </div>

                <!-- User history -->
                <ol v-else-if="activeTab===1">
                    <li v-for="(activityDate, i) in feed" :key="i">
                        <ul>
                            <header>
                                <span></span>
                                <time :datetime="activityDate.event_day">{{ formatDate(activityDate.event_day) }}</time>
                            </header>
                            <li v-for="(ev, j) in activityDate.events" :key="j">
                                <div class="event__row" :class="'event--' + 0 ">
                                    <span :class="'bg--' + ev.logo_name "></span>
                                    <div>
                                        <p class="title">
                                            {{ trans('dashboard.feed.user_edit_title') }}
                                            <span v-if="ev.subclient" :title="ev.subclient.name"> {{ ev.subclient.code }} </span>
                                        </p>
                                        <p class="content" v-html="contentTransformationUser(ev)" />
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </li>
                </ol> <!-- User history end -->


                <!-- Logistics -->
                <ol v-else>
                    <li v-for="(activityDate, i) in feed" :key="i">
                        <ul>
                            <header>
                                <span></span>
                                <time :datetime="activityDate.event_day">{{ formatDate(activityDate.event_day) }}</time>
                            </header>
                            <li v-for="(ev, j) in activityDate.events" :key="j">
                                <div class="event__row" :class="'event--' + ev.type">
                                    <span :class="'bg--' + ev.logo_name "></span>
                                    <div>
                                        <p class="title">
                                            {{ trans( 'dashboard.feed.logistics_title.' + ev.type) }}
                                            <span v-if="ev.subclient" :title="ev.subclient.name"> {{ ev.subclient.code }} </span>
                                        </p>
                                        <p class="content" v-html="contentTransformationLogistics(ev)" />
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </li>
                </ol> <!-- Logistics end -->

                <div class="feed__end">
                    <div class="zero__inner">
                        <div class="img__cont">
                            <img src="/images/icon_check_bg.svg">
                            <div>
                                <p class="title">{{ trans('dashboard.feed.end.title') }}</p>
                                <p class="subtitle">{{ trans('dashboard.feed.end.sub') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<style lang="scss" scoped >

</style>


<script>

import {trans, trans_choice} from "@common/tsutils/trans";

export default {

    props: [
        'widget',
        'subclients',
    ],

    data(){

        return {

            loading: false,

            myTabs: [
                {
                    'id': 'logistic',
                    'name': trans('dashboard.insiders.tabs.logistic'),
                    'active': true
                },
                {
                    'id': 'user',
                    'name': trans('dashboard.insiders.tabs.user'),
                    'active': false
                }
            ],

            activeTab: 0,
            feed: this.formatFeed(this.widget.data()),
        };
    },


    methods: {

        switchActiveTab(i) {

            this.myTabs.forEach((tab) => tab.active = false);
            this.myTabs[i].active = true;
            this.activeTab = i;

            this.loadData(i);
        },

        async loadData(option){

            this.loading = true;

            await this.widget.load(option);

            this.feed = this.formatFeed(this.widget.data(option));
            this.loading = false;
        },

        formatFeed(feed){

            return feed.map(day => {

                day.events = day.events.map(ev => {

                    if(this.subclients){
                        ev.subclient = this.subclients.filter(sub => sub.id === ev.client_id)[0];
                    }
                    return ev;

                });

                return day;

            });

        },

        contentTransformationUser(ev){

            const users = ev.users;
            const users_str = users.map(user => {

                return `<abbr title="${user.email}">${user.name}</abbr>`;

            }).join(', ');
            const num_properties = ev.properties.length;
            const samples = ev.samples.map(s => s.code);
            const samples_str = samples.join(', ');

            let text = '';

            text += trans_choice('dashboard.feed.user_edit.users', users, {users: users_str}) + ' ';
            text += trans_choice('dashboard.feed.user_edit.properties', num_properties) + ' ';
            text += trans_choice('dashboard.feed.user_edit.samples', samples, {codes: samples_str}) + ' ';

            return text;

        },

        contentTransformationLogistics (el) {

            const event = el.type.toLowerCase();

            const data = {
                codes: el.samples.map(x => x.c_muestra_wineseq).join(', '),
                crop: trans('common::crop.' + el.crop_name),
            };

            return trans_choice('dashboard.feed.logistics.' + event, el.samples, data);
        },
        formatDate (mydate) {
            let date = moment(mydate,"YYYY-MM-DD");
            let current = moment(new Date);

            let formattedDate = moment(mydate).format("DDMMM").replace(".","").toString()
            if (current.diff(date, 'days') > 365) formattedDate = moment(mydate).format("DDMMMYYYY").replace(".","").toString()
            return formattedDate
        }
    }
}

</script>